module.exports = __webpack_public_path__ + "static/media/img7.e5b8ca47.jpeg";